import { Grid, Drawer } from "@material-ui/core";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import {
  getCurrentEngineersAtSite,
  getCurrentEngineersAtSiteOverview,
  getStepsDropList,
} from "../../redux/reducers/dashboardReducers";
import { Text, SVG } from "sunrise-ui";
import List from "./List";
import WorkInProgressPilesDrawer from "./Drawer/PliesDrawer";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import { timeFormatter } from "../../utilities/timeHandler";
import { currentShift } from "../../utilities/utils";
import { Pie } from "react-chartjs-2";
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
);

const initialSteps: any = {
  "1": 0.05,
  "2": 0.05,
  "3": 0.05,
  "4": 0.05,
  "5": 0.05,
  "6": 0.05,
  "7": 0.05,
};

const CurrentEngineersAtSite = (props: any) => {
  const { engsInShifData, projectName } = props;
  const dispatch = useDispatch<AppDispatch>();
  const [currEngSiteInDetails, setCurrEngSiteInDetails] = useState([]);
  const [drawerData, setDrawerData] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [stepsData, setStepsData] = useState<any>({ ...initialSteps });

  const allProject = useSelector((state: any) => state.PROJECT.allProjectData);
  const WIPPiles = useSelector((state: any) => state.DASHBOARD.WIPPiles);
  const ranks = useSelector((state: any) => state.USERS.ranks);
  const [dataToDownload, setDataToDownload] = useState<any>([]);

  const openDrawer = (data: any) => {
    setDrawerData(data);
    setDrawerOpen(true);
  };

  //--------pie chart data----------
  const pieChartData = {
    labels: Object.keys(stepsData).map((val: any) => `Step ${val}`),
    datasets: [
      {
        label: "piles steps deyails",
        data: Object.keys(stepsData).map((c: any) => stepsData[c]),
        backgroundColor: [
          "#5F67E0",
          "#E8A838",
          "#4dd0e1",
          "#607d8b",
          "#94fa60",
          "#bbdefb",
          "#FCE100",
        ],
      },
    ],
  };

  useEffect(() => {
    if (Array.isArray(allProject)) {
      const project_id: any = allProject?.find(
        (val: any) => val?.projectName === props?.projectName
      )?._id;
      if (project_id) {
        dispatch(
          getCurrentEngineersAtSite({
            endPoint: `piles/engineers-at-site/list?shift=day&project=${project_id}`,
          })
        );
        dispatch(
          getCurrentEngineersAtSiteOverview({
            endPoint: `piles/engineers-at-site/overview?shift=day&project=${project_id}`,
          })
        );
      }
    }
    // eslint-disable-next-line
  }, [props?.projectName]);

  useEffect(() => {
    const engs = engsInShifData.map((val: any) => val?.pileDetails?.pileId);
    const curWIPPiles = WIPPiles?.filter((val: any) =>
      engs.includes(val?.pileId)
    );
    setCurrEngSiteInDetails(curWIPPiles);
    let obj: any = { ...initialSteps };
    for (let item of curWIPPiles) {
      const number = +item.stepNameNumber?.split(",")[0];
      obj[number] = obj[number] === 0.05 ? 1 : obj[number] + 1;
    }
    setStepsData(obj);
    // eslint-disable-next-line
  }, [engsInShifData, WIPPiles]);

  useEffect(()=>{
    let downloadData = currEngSiteInDetails?.map((ele:any)=>{
      return {
        'Pile Id': ele.pileId,
        'Step Number & Name':ele.stepNameNumber,
        'Machine Used':ele.machineUsed,
        'Last Worked by Engineer':ele.lastWorkedBy,
        'Step Work Started On':ele.startedOn,
      }
    })
    setDataToDownload(downloadData)
  },[currEngSiteInDetails]);
  const fields = [
    {
      header: "Pile Id",
      value: "pileId",
      search: true,
      action: function (obj: any) {
        return (
          <Text
            type="link"
            fonts="normal"
            fontSize={14}
            className="mb0 mt0 fw500 pointer"
            onTextClick={() => {
              dispatch(
                getStepsDropList({
                  endPoint: `piles/steps-filter?pileId=${obj?.id}`,
                })
              ).then(() => openDrawer(obj));
            }}
          >
            {obj.pileId}
          </Text>
        );
      },
    },
    {
      header: "Step Number & Name",
      search: true,
      value: "stepNameNumber",
    },
    { header: "Machine Used", value: "machineUsed", search: true },
    {
      header: "Last Worked by Engineer",
      value: "lastWorkedBy",
      search: true,
    },
    {
      header: "Step Work Started On",
      value: "startedOn",
      search: true,
    },
  ];
  return (
    <Grid className="bg--white box--shadow p1 mt1 mb1">
      <div> Current Engineers At Site Details </div>
      <Grid container>
        <Grid item md={4} xs={6}>
          <Grid className="p2 bg--white box--shadow mr-1 mt_low_space">
            <Pie data={pieChartData} />
          </Grid>
        </Grid>
        <Grid item md={8} xs={6}>
          <Grid container>
            <Grid item md={12} xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb0 mt0 fw500"
              >
                Engineers Information
              </Text>
            </Grid>
            <Grid item md={4} xs={6}>
              <Grid className="flex_between  box--shadow p0 v-center mt_low_space mr-1 smp">
                <Grid className="flex_start">
                  {currentShift() === "Day" ? (
                    <SVG type="morningBig" />
                  ) : (
                    <Grid className="night-icon mt_vlow_space mb_vlow_space mr">
                      <SVG type="night" />
                    </Grid>
                  )}

                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="mb0 mt_vlow_space fw500"
                  >
                    Ongoing Shift
                  </Text>
                </Grid>
                <Grid className="f14 fw400"> Day </Grid>
              </Grid>
            </Grid>

            <Grid item md={6} xs={6}>
              <Grid className="flex_between  box--shadow p0 v-center mt_low_space mr-1 smp">
                <Grid className="flex_start">
                  <SVG type="shiftTiming" />
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="mb0 mt_vlow_space fw500"
                  >
                    Shift Timing
                  </Text>
                </Grid>
                <Grid className="f14 fw400">
                  {" "}
                  {currentShift() === "Day"
                    ? "09:00 AM to 09:00 PM"
                    : "09:00 PM to 09:00 AM"}{" "}
                </Grid>
              </Grid>
              <Grid item md={2}></Grid>
            </Grid>
          </Grid>
          <div className="box--shadow p mt1 ">
            <Text
              type="normal"
              fonts="normal"
              fontSize={16}
              className="mb0 mt0 fw500"
            >
              Engineers in Shift ({engsInShifData?.length})
            </Text>
            <div className="available_operator_container">
              {engsInShifData?.map((val: any) => (
                <Grid className="total_box flex_start mt_low_space mr-1">
                  <Grid className="mr-1 d-flex">
                    <span>
                      <SVG type="engineer" />
                    </span>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb0 mt0 fw400 eng-name"
                    >
                      <span style={{ marginLeft: 8 }}>
                        {" "}
                        {val?.engineerDetails?.name}{" "}
                      </span>
                    </Text>
                  </Grid>

                  <Grid className="fw400 f14 mr-1 rank">
                    <>
                      Global Rank:{" "}
                      {ranks &&
                      ranks?.globalranks &&
                      ranks?.globalranks?.filter(
                        (item: any) => item?.empId === val?.empId
                      )[0]?.rank
                        ? ranks?.globalranks?.filter(
                            (item: any) => item?.empId === val?.empId
                          )[0]?.rank
                        : "NA"}
                    </>
                  </Grid>
                  <Grid className="fw400 f14 mr-1 rank">
                    <>
                      Project Rank:
                      {ranks &&
                      ranks?.projectranks &&
                      ranks?.projectranks[
                        allProject &&
                          allProject.filter(
                            (item: any) => item.projectName === projectName
                          )[0]._id
                      ]?.filter((item: any) => item.empId === val?.empId)[0]
                        ?.rank
                        ? ranks?.projectranks[
                            allProject &&
                              allProject.filter(
                                (item: any) => item.projectName === projectName
                              )[0]._id
                          ]?.filter((item: any) => item.empId === val?.empId)[0]
                            ?.rank
                        : "NA"}{" "}
                    </>
                  </Grid>
                  <Grid className="fw400 f14 mr-1 log">
                    {" "}
                    Logged in at{" "}
                    {timeFormatter(
                      new Date(val?.loginTime)
                    ).toLocaleUpperCase()}{" "}
                  </Grid>
                  <Text
                    type="link"
                    fonts="normal"
                    fontSize={14}
                    className="mb0 mt0 fw500 pile-id"
                    onTextClick={() => {
                      dispatch(
                        getStepsDropList({
                          endPoint: `piles/steps-filter?pileId=${val?.pileDetails?.id}`,
                        })
                      ).then(() => openDrawer(val?.pileDetails));
                    }}
                  >
                    {val?.pileDetails?.pileId}
                  </Text>
                </Grid>
              ))}
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid container>
        <List
          listData={currEngSiteInDetails}
          fields={fields}
          title="Current Engineers and Pile Filling Operation at Site"
          sizeType="small"
          nodataText="No data available for Current Engineers and Pile Filling Operation  at Site"
          project={props.projectName}
          dataToDownLoad={dataToDownload}
        />
      </Grid>
      {drawerData && (
        <Drawer
          anchor={"right"}
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <WorkInProgressPilesDrawer
            setDrawerOpen={setDrawerOpen}
            forPage="workinprogress"
            data={drawerData}
          />
        </Drawer>
      )}
    </Grid>
  );
};

export default CurrentEngineersAtSite;
